import { isEqual } from "lodash"
import PropTypes from "prop-types"
import React from "react"
import UseKey from "react-use/lib/comps/UseKey"

import { withTranslation } from "../../../i18n/translate"
import ArrowLeftIcon from "../../../images/icons/arrow_left.svg"
import ArrowRightIcon from "../../../images/icons/arrow_right.svg"
import CloseIcon from "../../../images/icons/close.svg"
import { GalleryItem } from "../model/gallery-item"
import LightboxPicture from "./lightbox-picture/lightbox-picture"
import LightboxVideo from "./lightbox-video/lightbox-video"
import LightboxZoomPicture from "./lightbox-zoom-picture/lightbox-zoom-picture"
import "./lightbox.sass"

const getLightboxContent = (item) => {
  switch (item.type) {
    case "VIDEO":
      return <LightboxVideo galleryVideo={item} />
    case "PICTURE":
      return <LightboxPicture galleryPicture={item} />
    case "ZOOM_PICTURE":
      return <LightboxZoomPicture galleryPicture={item} />
    default:
      return <></>
  }
}

class Lightbox extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      active: false,
      activeIndex: 0,
    }
  }

  componentDidMount() {
    if (this.props.onMount) {
      this.props.onMount({
        open: (item) => this.open(item),
      })
    }
  }

  open(item) {
    const index = this.props.items.findIndex((i) => isEqual(i, item))
    if (index === -1) return
    this.setState({ active: true, activeIndex: index })
  }

  close() {
    this.setState({ active: false })
  }

  next() {
    this.setState({
      activeIndex: (this.state.activeIndex + 1) % this.props.items.length,
    })
  }

  prev() {
    this.setState({
      activeIndex:
        (this.props.items.length + this.state.activeIndex - 1) %
        this.props.items.length,
    })
  }

  render() {
    const { t } = this.props
    const { active, activeIndex } = this.state
    return (
      <>
        {active && (
          <div className="_fp-lightbox">
            <UseKey filter={"Escape"} fn={() => this.close()} />
            <UseKey filter={"ArrowRight"} fn={() => this.next()} />
            <UseKey filter={"ArrowLeft"} fn={() => this.prev()} />
            <div
              role={"button"}
              aria-label={t("GLOBAL-CLOSE_GALLERY")}
              className="_fp-lightbox__overlay"
              onClick={() => this.close()}
            />
            <div className="_fp-lightbox__content">
              {getLightboxContent(this.props.items[activeIndex])}
            </div>
            <div className="_fp-lightbox__controls">
              <button
                aria-label={t("GLOBAL-CLOSE_GALLERY")}
                className={"_fp-lightbox__controls__button-close"}
                onClick={() => this.close()}
              >
                <CloseIcon />
              </button>

              {this.props.items.length > 1 && (
                <>
                  <button
                    aria-label={t("GLOBAL-PREVIOUS_IMAGE")}
                    className={"_fp-lightbox__controls__button-left"}
                    onClick={() => this.prev()}
                  >
                    <ArrowLeftIcon />
                  </button>
                  <button
                    aria-label={t("GLOBAL-NEXT_IMAGE")}
                    className={"_fp-lightbox__controls__button-right"}
                    onClick={() => this.next()}
                  >
                    <ArrowRightIcon />
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </>
    )
  }
}

Lightbox.propTypes = {
  items: PropTypes.arrayOf(PropTypes.instanceOf(GalleryItem)).isRequired,
  onMount: PropTypes.func,
}

export default withTranslation()(Lightbox)
